import React from 'react'
import {  Container  } from '@mui/material'

const CreateTemplate = ({ onSelect }) => {
  return (
     <Container maxWidth='lg' sx={{ minWidth: '80vw' }}>
    </Container>
  )
}

export default CreateTemplate
